import type { Gradient } from '@jouzen/ecom-components';

const stressFeaturesGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#715f74',
    id: 'purple-1',
    position: [10, 5],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#715f74',
    id: 'purple-2',
    position: [90, 40],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#715f74',
    id: 'purple-3',
    position: [5, 80],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#715f74',
    id: 'purple-4',
    position: [90, 70],
    opacity: 1,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#715f74',
    id: 'purple-5',
    position: [60, 99],
    opacity: 1,
    size: 30,
  },
];

export default stressFeaturesGradients;
